import { jsx as _jsx } from "react/jsx-runtime";
import MenuItem from '@mui/material/MenuItem';
import MuiSelect from '@mui/material/Select';
export default function Select({ items = [], ...props }) {
    return (_jsx(MuiSelect, { variant: props.variant, ...props, children: items.map(({ title, ...menuItemProps }, i) => (_jsx(MenuItem, { ...menuItemProps, children: title }, i))) }));
}
export * from '@mui/material/Select';
